import styled from 'styled-components'
import { theme } from '../../../shared/styles/theme'

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;

    .retail-name {
        align-self: flex-start;
        margin-top: -32px;
        color: ${theme.colors.grey};
        font-size: 16px;
    }

    .inputs-group {
        margin: 40px 0;
        width: 100%;

        .input-container + .input-container {
            margin-top: 16px;
        }

    }

    .view-qr-code {
        display: flex;
        align-items: center;
        justify-content: center;

        height: 100px;
        border-radius: 8px;
        background-color: #E4E7F5;
        text-decoration: none;

        span {
            color: ${theme.colors.blue};
            font-size: 14px;
            margin-left: 8px;
        }
    }
    
    .submit-button {
        align-self: center;
    }
`
